<div *ngIf="!loading">
    <div class="header">
        We have a number of available payment options to choose from:
    </div>
    <div class="d-flex flex-row payment-options-container">
        <div *ngIf="!isCollectionServicePaymentAvailable" class="payment-option ">
            <img (click)="selectFastPayment()" *ngIf="isFastPaymentAvailable" class="payment-image"
                src="../../assets/images/PaymentFast.png" alt="">
            <img *ngIf="!isFastPaymentAvailable" class="payment-image" src="../../assets/images/PaymentFastInactive.png"
                alt="">
            <div class="payment-type">Immediate Payment*</div>
            <div *ngIf="isFastPaymentAvailable" class="payment-fee">{{fastPaymentCharge | currency : 'GBP'}}</div>
            <div *ngIf="!isFastPaymentAvailable" [ngClass]="isFastPaymentAvailable ? '' : 'margin-text'"
                 class="payment-availability"> Immediate Payment is not available</div>
            <div *ngIf="isFastPaymentAvailable" (click)="selectFastPayment()"
                [ngClass]="isFastPaymentSelected ? 'check-payment' : 'uncheck-payment'" class="payment-availability">
            </div>
        </div>
        <div *ngIf="!isCollectionServicePaymentAvailable" class="payment-option">
            <img (click)="selectNextDayPayment()" *ngIf="isNextDayPaymentAvailable" class="payment-image"
                src="../../assets/images/Payment24H.png" alt="">
            <img *ngIf="!isNextDayPaymentAvailable" class="payment-image"
                src="../../assets/images/Payment24Inactive.png" alt="">
            <div class="payment-type">Next Working Day</div>
            <div *ngIf="isNextDayPaymentAvailable" class="payment-fee">{{nextDayPaymentCharge | currency : 'GBP'}}</div>
            <div *ngIf="!isNextDayPaymentAvailable" [ngClass]="isFastPaymentAvailable ? '' : 'margin-text'"
                class="payment-availability next-day-availability"> Next Working Day
                Payment is not available</div>
            <div *ngIf="isNextDayPaymentAvailable" (click)="selectNextDayPayment()"
                [ngClass]="isNextDayPaymentSelected ? 'check-payment' : 'uncheck-payment'" class="payment-availability">
            </div>
        </div>
        <div *ngIf="!isCollectionServicePaymentAvailable" class="payment-option">
            <img (click)="selectBacsPayment()" class="payment-image" src="../../assets/images/PaymentBacs.png" alt="">
            <div class="payment-type">4 Working Days</div>
            <div class="payment-fee">Free</div>
            <div (click)="selectBacsPayment()" [ngClass]="isBacsPaymentSelected ? 'check-payment' : 'uncheck-payment'"
                class="payment-availability"></div>
        </div>
        <div *ngIf="isPremiumServicePaymentAvailable && !isCollectionServicePaymentAvailable" class="payment-option">
            <img (click)="selectPremiumServicePayment()" class="payment-image" src="../../assets/images/PaymentSilver.png" alt="">
            <div class="payment-type">Premium Service**</div>
            <div class="payment-fee">{{premiumServicePaymentCharge | currency : 'GBP'}}</div>
            <div (click)="selectPremiumServicePayment()" [ngClass]="isPremiumServicePaymentSelected ? 'check-payment' : 'uncheck-payment'"
                class="payment-availability"></div>
        </div>
        <div *ngIf="isCollectionServicePaymentAvailable" class="payment-option">
            <img (click)="selectCollectionServicePayment()" class="payment-image" src="../../assets/images/PaymentGold.png" alt="">
            <div class="payment-type">Collection Service***</div>
            <div class="payment-fee">{{collectionServicePaymentCharge | currency : 'GBP'}}</div>
            <div (click)="selectCollectionServicePayment()" [ngClass]="isCollectionServicePaymentSelected ? 'check-payment' : 'uncheck-payment'"
                class="payment-availability"></div>
        </div>
    </div>
    <div class="footer">
        <div *ngIf="!isCollectionServicePaymentAvailable">*We'll send your payment to the bank within 15 minutes. Immediate Payments may take up to 2 hours to arrive in your account</div>
        <div *ngIf="isPremiumServicePaymentAvailable && !isCollectionServicePaymentAvailable">**We will send you home in a taxi and will send your payment to the bank on the same day</div>
        <div *ngIf="isCollectionServicePaymentAvailable">***Your car will be collected from your home and we'll send your payment to the bank on the same day</div>
    </div>
</div>
